import { useState } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// value: "YYYY-MM-DDTHH:MM:SS" (local, no timezone)
export const DateTimePicker = ({ value, onChange, withTime = true, testId = "date-picker" }) => {
  const [open, setOpen] = useState(false);
  const [datePart, timePart = "20:00:00"] = (value || "").split("T");
  const selected = datePart ? new Date(`${datePart}T00:00:00`) : undefined;
  const emit = (d, t) => onChange(`${d}T${t.length === 5 ? `${t}:00` : t}`);

  return (
    <div className="flex gap-3" data-testid={testId} data-value={value || ""}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={`${testId}-trigger`} className="flex-1 h-12 border border-white/20 px-4 flex items-center gap-3 text-left text-white hover:border-white transition-colors">
            <CalendarIcon className="w-4 h-4 text-primary" />
            {selected ? format(selected, "EEEE d MMMM yyyy", { locale: fr }) : <span className="text-zinc-500">Choisir une date</span>}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 rounded-none bg-black border-white/10 z-[200]" align="start">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => {
              if (!d) return;
              emit(format(d, "yyyy-MM-dd"), timePart);
              setOpen(false);
            }}
            locale={fr}
            initialFocus
            data-testid={`${testId}-calendar`}
          />
        </PopoverContent>
      </Popover>
      {withTime && (
        <input
          type="time"
          value={timePart.slice(0, 5)}
          onChange={(e) => datePart && emit(datePart, e.target.value)}
          disabled={!datePart}
          data-testid={`${testId}-time`}
          className="w-32 h-12 border border-white/20 bg-transparent px-3 text-white [color-scheme:dark] disabled:opacity-40"
        />
      )}
    </div>
  );
};
